import * as actionTypes from 'modules/audits/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = false;

const setLoading = (state, newValue, meta) => {
  if (meta.source === 'link-audit') {
    return newValue;
  }
  return state;
};

const isLoading = (state, { meta }) => setLoading(state, true, meta);

const isEnding = (state, { meta }) => setLoading(state, false, meta);

export default createReducer(initialState, {
  [actionTypes.FETCH_AUDITS_REQUEST]: isLoading,
  [actionTypes.FETCH_AUDITS_SUCCESS]: isEnding,
  [actionTypes.FETCH_AUDITS_FAILURE]: isEnding,
});
